import React from 'react';
import withExtensionContextConsumer from '../../../hoc/withExtensionContextConsumer';

const getSubtitle = (last4, refunded) => {
  if (refunded) return 'Your order has been successfully refunded.';
  return last4 ? 'Your card was successfully charged.' : 'Your were successfully charged.';
};

// eslint-disable-next-line react/prop-types
const Title = ({ logoUrl, last4, refunded, extension = {} }) => (
  <div className="c-receipt-title">
    <img className="u-hide-on-desktop u-mb-12" width="64px" height="64px" src={logoUrl} alt="Logo" />
    <h2 className="u-text-huge u-fw-bold u-mt-2 u-mb-2">
      { refunded ? 'Refunded!' : 'Thank you!' }
    </h2>
    <div>
      <div className="u-text-normal">
        {getSubtitle(last4, refunded)}
      </div>
    </div>
    {
      extension.appIconImage && (
        <img
          className="c-receipt-title__logo u-hide-on-mobile"
          width="90px"
          height="90px"
          src={extension.appIconImage}
          alt="Logo"
        />
      )
    }
  </div>
);

export default withExtensionContextConsumer(Title);



// WEBPACK FOOTER //
// ./src/app/notifications/customer/Receipt/components/Title.jsx